/* 🤖 this file was generated by svg-to-ts */
export const siriusInfoDuotone: {
  name: 'info_duotone';
  data: string;
} = {
  name: 'info_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M21 12a9 9 0 1 1-17.999 0A9 9 0 0 1 21 12Z" fill="currentColor"/><path d="M13.5 16.5a.75.75 0 0 1-.75.75 1.5 1.5 0 0 1-1.5-1.5V12a.75.75 0 1 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 0 1 .75.75Zm8.25-4.5A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12Zm-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12Zm-8.625-3a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" fill="currentColor"/></svg>`
};
